<template>
  <div>
    <CRow>
      <CCol md="12">
        <CCard>
          <CCardBody>
            <BTabs :active-tab.sync="active_tab">


              <CTab :title="$t('newFactor')">
                <AddDocumentNew :selectedType="3" :key="invoice_key"/>
              </CTab>
              <CTab :title="$t('orders')">
                <SellDocumentListPreOrders/>
              </CTab>

              <CTab :title="$t('factorLists')">
                <SellDocumentListFinal/>
              </CTab>

              <CTab v-if="get_access('credit_factors')" :title="$t('CreditFactors')">
                <SellCreditDocumentList/>
              </CTab>

            </BTabs>
          </CCardBody>
        </CCard>
      </CCol>
    </CRow>

  </div>
</template>

<script>
import axios from "axios";
import {bus} from '../../../main';
var items = [];
import BTabs from "../../tabs/BTabs";

import AddDocumentNew from "@/views/panel/documents/AddDocumentNew";
import SellDocumentListFinal from "./SellDocumentListFinal";
import SellDocumentListPreOrders from "./SellDocumentListPreOrders";
import SellCreditDocumentList from "@/views/panel/sell/SellCreditDocumentList";
export default {
  name: 'Login',
  components: {
    BTabs,
    AddDocumentNew,
    SellDocumentListFinal,
    SellDocumentListPreOrders,
    SellCreditDocumentList
  },
  data() {
    return {

      active_tab:parseInt(localStorage.getItem("sale_factors_active_tab",0)),
invoice_key:0,

    }
  }, mounted() {

    bus.$on('reload_invoice_component', (data) => {
      // alert(data);
      this.invoice_key++;
    });
  }, watch: {
    'active_tab': function () {
      localStorage.setItem("sale_factors_active_tab",this.active_tab)
    },

  },
  methods: {



  }
}

</script>
